/**
 * WS-3 (HITL-1411): serialize a value to JSON for logging with a hard size cap.
 *
 * Hot-path logs — notably the per-flush "non-audio message" log on the event
 * socket — can carry very large `hypothesis`/`check` payloads (the full replayed
 * dialog). Shipping the entire blob to New Relic on every 100ms flush is
 * wasteful in both serialization cost and log volume. This caps the serialized
 * string and appends a truncation marker with the original length so the loss
 * is visible rather than silent.
 */
export const MAX_LOG_JSON_CHARS = 4000;

export const cappedJson = (
  value: unknown,
  maxChars: number = MAX_LOG_JSON_CHARS
): string => {
  const serialized = JSON.stringify(value);
  // JSON.stringify returns undefined for e.g. `undefined`/functions.
  if (serialized == null) return String(serialized);
  if (serialized.length <= maxChars) return serialized;
  return `${serialized.slice(0, maxChars)}…[truncated: ${
    serialized.length
  } chars]`;
};
